export const MOJO_FORM_SUBMITTED_EVENT = "mojo.form.submitted" as const;

export type MojoFormSubmittedEventPayload = {
  type: typeof MOJO_FORM_SUBMITTED_EVENT;
  responseId: string;
  projectId: string;
  formId: string;
  versionNumber: number;
  projectSlug: string;
  formSlug: string;
  submittedAt: string;
};

export function emitMojoFormSubmittedEvent(
  payload: MojoFormSubmittedEventPayload,
): void {
  console.log("emitMojoFormSubmittedEvent", payload);
  if (typeof window === "undefined") {
    return;
  }

  if (window.parent === window) {
    return;
  }

  window.parent.postMessage(payload, "*");
}
